export default "__VITE_ASSET__BrtH32hq__"